import { render, staticRenderFns } from "./LeaveOfAbsence.vue?vue&type=template&id=f1e2205c"
import script from "./LeaveOfAbsence.vue?vue&type=script&lang=js"
export * from "./LeaveOfAbsence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports